export default __webpack_public_path__ + "static/media/MARDOM2025.4995c433.png";